import { render } from "./ContentTranslationResultView.vue?vue&type=template&id=331c4a98"
import script from "./ContentTranslationResultView.vue?vue&type=script&lang=js"
export * from "./ContentTranslationResultView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__